<template>
    <div class="wrap">
        <TheHeader />

        <main>
            <div class="content">

                <!-- 카테고리 소개 -->
                <div class="about_box mtb80">
                    <div class="items inner">

                        <div class="item">
                            <div class="img">
                                <img src="@/assets/zeb01.png" alt="">
                            </div>
                            <div class="info">
                                <h3>BIPV 모듈</h3>
                                <p>도시의 외벽을 발전소로 바꾸는 BIPV 모듈 제품을 소개해 드립니다.</p>
                                <button type="button" @click="showPopup(1)">홍보업체</button>
                            </div>
                        </div>

                        <div class="item">
                            <div class="img">
                                <img src="@/assets/zeb03.png" alt="">
                            </div>
                            <div class="info">
                                <h3>단열재 제품</h3>
                                <p>건물 에너지 성능을 함께 끌어올릴 단열재 제품을 소개해 드립니다.</p>
                                <button type="button" @click="showPopup(2)">홍보업체</button>
                            </div>
                        </div>

                        <div class="item">
                            <div class="img">
                                <img src="@/assets/zeb02.png" alt="">
                            </div>
                            <div class="info">
                                <h3>시공사</h3>
                                <p>정확한 시공과 꼼꼼한 마감으로 신뢰를 쌓아온 기록을 소개해 드립니다.</p>
                                <button type="button" @click="showPopup(3)">홍보업체</button>
                            </div>
                        </div>

                        <div class="item">
                            <div class="img">
                                <img src="@/assets/zeb04.png" alt="">
                            </div>
                            <div class="info">
                                <h3>모니터링/유지관리 기술</h3>
                                <p>설치 이후의 점검, 고장 진단 서비스를 쌓아온 기록을 소개해 드립니다.</p>
                                <button type="button" @click="showPopup(4)">홍보업체</button>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 플랫폼 로고 영역 -->
                <div class="platform ptb80">
                       
                    <div class="text inner">
                        <h2 class="size120">BIM-ZENS PLATFORM</h2>
                        <p class="size60">BIM-ZENS PLATFORM에 참여할 기업들을 모집합니다.</p>

                        <div class="inner" style="text-align: center;">
                            <img src="@/assets/logo_area.png" alt="BIM-ZENS PLATFORM LOGOS" style="max-width: 100%; height: auto;">                    
                        </div>    

                        <!--div class="logos">
                            <div
                                class="item"
                                v-for="(label, key) in typeMap"
                                :key="key"
                            >
                                <h3>{{ label }}</h3>
                                <ul>
                                    <li
                                        v-for="company in companiesByType(key)"
                                        :key="company.id"
                                    >
                                        <img
                                            :src="company.img_path
                                                ? apiBase + company.img_path
                                                : apiBase + '/img/no_logo.png'"
                                            :alt="company.company"
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="btns">
                            <button class="buttn" type="button" @click="$router.push({ path: '/inquire_form', query: { type: '7' } })">
                                업체 등록 문의하기
                            </button>
                        </div-->
                    </div>
                </div>

            </div>
        </main>

        <TheFooter />
    </div>

    <!-- 팝업 -->
    <div class="popup" v-if="isPopupVisible">
        <div class="pop_in">
            <div class="head">
                <h2>{{ typeMap[currentType] }}</h2>
                <span class="close" @click="hidePopup">
                    <img src="@/assets/close.svg" alt="닫기">
                </span>
            </div>

            <div class="body">
                <h2>소개 리스트</h2>
                <div class="list">
                    <ul>
                        <li
                            v-for="(item, index) in filteredCompanies"
                            :key="item.id"
                        >
                            <router-link
                                :to="'/bipv_modul/?id=' + item.id"
                                class="item"
                            >
                                {{ index + 1 }}. {{ item.company }}
                                <span>더보기</span>
                            </router-link>
                        </li>
                    </ul>

                    <p
                        v-if="filteredCompanies.length === 0"
                        class="empty"
                    >
                        등록된 업체가 없습니다.
                    </p>
                </div>
        <div class="align-center"><button v-if="user && user.level == 5" class="buttn mt20" type="button" @click="goRegister"> 등록 신청 </button></div>
            </div>
        </div>
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import api from '@/api'

export default {
    name: 'ZebManufacturer',
    components: {
        TheHeader,
        TheFooter
    },
    data() {
        return {
            zebCompanies: [],
            isPopupVisible: false,
            currentType: null,
            user: null,    
            apiBase: api.defaults.baseURL,
            typeMap: {
                1: 'BIPV 모듈 분야',
                2: '단열재 제품 분야',
                3: '시공사 분야',
                4: '모니터링/유지관리 기술 분야'
            }
        }
    },
    mounted() {
        this.checkLogin()
        this.loadCompanies()
    },
    computed: {
        filteredCompanies() {
            return this.zebCompanies.filter(
                item => Number(item.type) === Number(this.currentType)
            )
        }
    },
    methods: {
        async checkLogin() {
            try {
                const res = await api.get('/admin/user-info', {
                    withCredentials: true
                })

                if (res.data.loggedIn) {
                    this.user = res.data.user
                }

            } catch (e) {
                this.user = null
            }
        },

        /* 업체 목록 */
        loadCompanies() {
            api.get('/admin/zeb_company')
                .then(res => {
                    this.zebCompanies = res.data
                })
                .catch(err => {
                    console.error('zeb_company 로딩 실패', err)
                })
        },
        showPopup(type) {
            this.currentType = type
            this.isPopupVisible = true
        },
        hidePopup() {
            this.isPopupVisible = false
            this.currentType = null
        },
        companiesByType(type) {
            return this.zebCompanies.filter(
                item => Number(item.type) === Number(type)
            )
        },

        /* 등록 페이지 이동 */
        goRegister() {
            this.$router.push({
                path: '/zeb_register',
                query: {
                    type: this.currentType
                }
            })
        }
    }
}
</script>